import { createSelector } from 'reselect';

export const productsSelector = (state) => state.products;

export const productsObjectsSelector = createSelector(
  productsSelector,
  (products) => products.objects,
);

export const productsLoadingSelector = createSelector(
  productsSelector,
  (products) => products.loading,
);

export const productsPageSelector = createSelector(
  productsSelector,
  (products) => products.page,
);

export const productsHasMoreSelector = createSelector(
  productsSelector,
  (products) => products.hasMore,
);
